import { fetchWrapper } from "../helpers/fetchWrapper";

const baseUrl = `${process.env.REACT_APP_API_URL}/parksapi/`;
const username = process.env.REACT_APP_API_USERNAME;
const password = process.env.REACT_APP_API_PASSWORD;

const getTokenLink = "GetToken"
const redirectLink = "Redirect"

export const parksWebService = {
    authenticate,
    getRedirectByKey,
}

function authenticate() {
    return fetchWrapper.post(`${baseUrl}${getTokenLink}`, { username, password })
}

function getRedirectByKey(key) {
    return fetchWrapper.get(`${baseUrl}${redirectLink}/${key}`)
}
